import {Component, Input, EventEmitter, Output, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {AuthService} from "../../../../services/auth.service";
import {FlagType} from "../../../../shared/utils/enums";
import {FlagService} from "../../../../shared/services/flag.service";
import {civilityOptions} from "../../../../shared/utils/data/etablissments-data";
import e from "express";

@Component({
  selector: 'app-first-form-step',
  templateUrl: './first-form-step.component.html',
  styleUrl: './first-form-step.component.scss'
})
export class FirstFormStepComponent implements OnInit {
  @Input() firstStepFormControl: FormGroup;
  @Input() type: string | null;
  @Output() onSubmit = new EventEmitter<any>();
  loading = false;
  
  showPassword: boolean

  constructor(private authService: AuthService, private flag: FlagService) {

  }
  get passwordFormField() {
    return this.firstStepFormControl.get('password')?.value;
  }
  nextStep(): void {

    if (this.firstStepFormControl.valid) {
      this.loading = true
      const body = {
        email: this.firstStepFormControl.get('email')?.value,
        password: this.firstStepFormControl.get('password')?.value,
        kind: this.type?.toUpperCase()
      }
      this.authService.signup(body).subscribe({
          next: (res) => {
            if (res.status == 'success') {
              this.firstStepFormControl.get('id')?.patchValue(res.data.id)
              localStorage.setItem('user', JSON.stringify(res.data))
              this.authService.setUser(res.data)
              this.onSubmit.emit()
            }
          },
          error: (e) => {
            this.flag.displayFlag(
              e.error.errors.full_messages[0] === 'Email has already been taken' ? 'email déjà existant ' : e.error.errors.full_messages[0],
              FlagType.error,
              2
            )
            this.loading = false
          },
          complete: () => this.loading = false
        }
      )

    }
  }

  protected readonly civilityOptions = civilityOptions;

  ngOnInit(): void {
    this.authService.setUser(null)
  }

  changeType() {
    this.type = this.type === 'candidat' ? 'etablissement' : 'candidat'
  }
}
